import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ReactToPrint from "react-to-print";
import BanHangApi from "service/QuanLyMuaBan/BanHangApi";
import { formatNumber } from "utils/currencyFormat";

const ChenhLechTable = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <table className="tableIn">
                <tbody>
                    <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>Không có tài sản.</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    return (
        <table className="tableIn">
            <thead>
                <tr>
                    <th style={{ textAlign: "center" }}>STT</th>
                    <th>Tên tài sản</th>
                    <th>Thông tin TS</th>
                    <th style={{ textAlign: "right" }}>Tổng giá nhập</th>
                    <th style={{ textAlign: "right" }}>Phí sản xuất</th>
                    <th style={{ textAlign: "right" }}>Tổng giá bán</th>
                    <th style={{ textAlign: "right" }}>Chênh lệch</th>
                </tr>
            </thead>
            <tbody>
                {data.map((ts, i) => {
                    const tongGiaNhap = (ts.GiaNhap || 0);
                    const phiSanXuat = (ts.PhiSanXuat || 0);
                    const tongGiaBan = (ts.TongTienBan || 0);
                    const chenhLech = tongGiaBan - tongGiaNhap - phiSanXuat;
                    return (
                        <tr key={ts.MaTaiSan || i}>
                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                            <td>{`${ts.TenTaiSan} (Mã: ${ts.MaTaiSan})`}</td>
                            <td>{ts.ThongTinTaiSan || ""}</td>
                            <td style={{ textAlign: "right" }}>{formatNumber(tongGiaNhap)}</td>
                            <td style={{ textAlign: "right" }}>{formatNumber(phiSanXuat)}</td>
                            <td style={{ textAlign: "right" }}>{formatNumber(tongGiaBan)}</td>
                            <td style={{ textAlign: "right" }}>{formatNumber(chenhLech)}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

const InPhieuChenhLech = ({ show, onHide, orderId }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [templateParts, setTemplateParts] = useState([]);
    const [tableData, setTableData] = useState([]);
    const printRef = useRef();

    useEffect(() => {
        if (orderId > 0 && show) {
            setLoading(true);
            setError(null);
            Promise.all([
                BanHangApi.getInChenhLech(orderId),
                BanHangApi.getChiTietInDonHang(orderId)
            ]).then(([resTemplate, resData]) => {

                let partialHtml = resTemplate.data || "Lỗi template";
                const data = resData.data;
                const parts = partialHtml.split("{$DanhSachTaiSan}");
                setTemplateParts(parts);
                setTableData(data?.DanhSachTaiSan || []);

            }).catch(err => {
                console.error(err);
                setError("Lỗi tải dữ liệu phiếu in.");
            }).finally(() => {
                setLoading(false);
            });
        }
    }, []);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            className="modal fade text-left popup-detail"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header style={{ borderBottom: "none" }}>
                <h4 className="modal-title">
                    <span className="btn-icon-right"><img src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png" alt="logo" style={{ height: 24 }} /></span>
                    <span style={{ fontWeight: "bold" }}>In phiếu chênh lệch</span>
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>

            <Modal.Body id="in_ChenhLech_content">
                {loading && (
                    <div className="text-center py-4"><Spinner animation="border" /></div>
                )}
                {error && (
                    <div className="text-center py-4 text-danger">{error}</div>
                )}
                {!loading && !error && templateParts.length > 0 && (
                    <div ref={printRef} className="print-area">
                        {templateParts.map((part, index) => (
                            <React.Fragment key={index}>
                                <div dangerouslySetInnerHTML={{ __html: part }} />
                                {index < templateParts.length - 1 && (
                                    <ChenhLechTable data={tableData} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                )}
                <style>{`
                    #in_ChenhLech_content p, #in_ChenhLech_content table {
                    font-size: 1.1rem; 
                    }
                     .tableIn { width: 100%; border: 1px solid #CACFE7; border-collapse: collapse; }
                     .tableIn th, .tableIn td { border: 1px solid #CACFE7; padding: 5px; }
                 `}</style>
            </Modal.Body>
            <style>{`
                 .popup-detail .back-ground-footer{
                     background-color: #FFFFFF !important;
                     border-bottom-left-radius: 0.5rem; 
                     border-bottom-right-radius: 0.5rem;
                 }
             `}</style>
            <Modal.Footer className="back-ground-footer">
                <ReactToPrint
                    trigger={() => (
                        <button disabled={loading || !!error} className="btn btn-checknew">
                            <i className="mdi mdi-printer"></i> In phiếu
                        </button>
                    )}
                    content={() => printRef.current}
                    documentTitle={`PhieuChenhLech_${orderId}`}
                />
                <button onClick={onHide} className="btn btn-v2-close" style={{ minHeight: 40 }}>
                    <i className="mdi mdi-close"></i> Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default InPhieuChenhLech;